import {defineStore} from 'pinia'

export const useDiscountTimerStore = defineStore('discountTimer', {
	state: () => ({
		endTime: null as Date | null,
		time: { hours: 0, minutes: 0, seconds: 0, totalSeconds: 0 },
		interval: null as number | null,
		discountType: 1,
		initDurationSeconds: 0
	}),

	getters: {
		getTime: (state) => state.time,
		getDiscountType: (state) => state.discountType,
		getInterval: (state) => state.interval
	},

	actions: {
		init(durationSeconds: number) {
			const saved = localStorage.getItem('discount_end_time')
			const savedDiscountType = localStorage.getItem('discount_type')
			let endTime

			this.initDurationSeconds = durationSeconds

			if (saved) {
				endTime = new Date(saved)
			} else {
				endTime = new Date(Date.now() + durationSeconds * 1000)
				localStorage.setItem('discount_end_time', endTime.toISOString())
			}

			this.endTime = endTime

			if (savedDiscountType) {
				this.discountType = parseInt(savedDiscountType)
			} else {
				localStorage.setItem('discount_type', this.discountType.toString())
			}

			this.start()
		},

		start() {
			if (this.interval) return

      this.interval = setInterval(() => {
        this.tick()
      }, 1000)
			this.tick() // сразу обновить
		},

		stop() {
			if (this.interval) {
				clearInterval(this.interval)
				this.interval = null
			}
		},

		tick() {
			if (!this.endTime) return

			const now = new Date()
			const diff = Math.max(0, this.endTime.getTime() - now.getTime())

			const totalSeconds = Math.floor(diff / 1000)
			const hours = Math.floor(totalSeconds / 3600)
			const minutes = Math.floor((totalSeconds % 3600) / 60)
			const seconds = totalSeconds % 60

			this.time = { totalSeconds, hours, minutes, seconds }

			if (totalSeconds <= 0) {
				if (this.discountType < 3) {
					const newDiscountType = 1 + this.discountType
					localStorage.setItem('discount_type', newDiscountType.toString())
					this.discountType = newDiscountType
					const endTime = new Date(Date.now() + this.initDurationSeconds * 1000)
					localStorage.setItem('discount_end_time', endTime.toISOString())
					this.endTime = endTime
				} else {
					this.stop()
				}
			}
		}
	}
})
